import { Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces';
import { TitleBlock } from '../../../atoms';
import './moveComfoftably.scss'
import { getContactDetails } from "../../../graphql/getContacts.query";
import { SMSContacts } from "../../../graphql/sendContacts.query";
import { getCustomerId, getRandomNumber } from '../../../utils/Utils';
import { Spinner, Button, Cards, CustomIcon } from 'ams-ui-reactkit';

const MoveComfortably: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props;
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [sendStatus, setSendStatus] = useState("")
    const [msgLoader, setMsgLoader] = useState(false)
    const showCloseBtnFlag = process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE ? process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE === "true" : false


    const customerId = getCustomerId();
    useEffect(() => {
        if (customerId) {
            getContactData()
        }

    }, [])
    // SEND SMS 
    const sendContacts = async () => {
        setMsgLoader(true)
        await SMSContacts(customerId).then((dataResults: any) => {
            let res = dataResults?.data?.sendContacts?.status
            if (res) {
                setSendStatus("SMS sent Successfully")
            }
            else {
                setSendStatus("SMS send Failed!")
            }
            setMsgLoader(false)
        }).catch((error: any) => {
            console.log("send Contacts :  Error:", error)
            setSendStatus("SMS send Failed!")
            setMsgLoader(false)
        })
    }

    // TO READ DATA FROM API
    const getContactData = async () => {
        setLoading(true)
        getContactDetails(customerId).then((dataResults: any) => {
            console.log(dataResults)
            setData(dataResults)
            setLoading(false)
        }).catch((error: any) => {
            console.log("get Contacts :  Error:", error)
            setLoading(false)

        })
    }
    const SingleBlockItem = (item: any) => {
        return (<div className='my-16 mx-0'>
            <Typography variant="h6" className='color-grey'>{item.title} </Typography>
            {item?.contacts?.map((contact: any, pageIndex: number) => <div className="mt-8" key={pageIndex + getRandomNumber()}><React.Fragment key={pageIndex + getRandomNumber()}>
                <Typography variant="body2" className='color-grey'>{contact.name}</Typography>
                <Typography variant="body2" className='color-grey'>{contact.phoneNumber}</Typography></React.Fragment></div>)}
        </div>)
    }

    const handleSMS = () => {
        sendContacts()
    }

    const renderContactsDetails = () => {

        if (loading) {
            return <Spinner />;
        }

        return data && data.map((item: any, pageIndex: any) => {
            return <SingleBlockItem key={pageIndex + getRandomNumber()} {...item} />
        });

    }

    const showCloseButton = () => {

        if (showCloseBtnFlag) {

            return <div className={`sendMessageBtn mt-8 in-active-btn-close`}>
                <Button
                    text="Close"
                    onClick={() => {
                        window.location.href = "/close"
                    }}
                    color="primary"
                    variant="contained"
                    size="medium"
                />
            </div>
        }

        return null;

    }

    return (

        <React.Fragment>
            <div className="baseContainerBlock">
                {templateProps.title && <TitleBlock title={templateProps.title} />}

                <div className="moveConfortablyMain">
                    <Cards variant="default">
                        <div className="moveConfortablyCard">
                            <div className='mb-16'>
                                <CustomIcon iconName="movewithus" />
                            </div>
                            <div>
                                <CustomIcon iconName="comfortably" />
                            </div>
                        </div>
                        <div className="moveConfortablySecondaryBlock">
                            <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} className='mb-n-8 color-grey'>
                                {"We Got This!"}
                            </Typography>

                            {renderContactsDetails()}

                            <div >
                                {
                                    sendStatus && <div className="messageStatus">
                                        <CustomIcon iconName="checkmark2" />
                                        <Typography variant="body1" component="span" className="color-green">{sendStatus}
                                        </Typography>
                                    </div>

                                }

                            </div>
                            <div className={`sendMessageBtn ${sendStatus ? "d-none" : ""}`}>
                                <Button
                                    text={templateProps?.button}
                                    onClick={() => {
                                        if (!msgLoader) {
                                            handleSMS()
                                        }
                                    }}
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    loading={msgLoader}
                                />
                            </div>
                            {showCloseButton()}

                        </div>

                    </Cards>
                </div>

            </div>
        </React.Fragment>
    )
}

export default MoveComfortably;
